require('./bootstrap');
require('./components');

const app = new Vue({
    el: '#app',
    methods:{
        cdmHandler(){
            window.addEventListener("message",function(e){
                if(e.data == "requestJindo"){// from parent cdm
                    console.log('awContents cdm loaded');
                    let tempIndex = location.href.indexOf('.htm');
                    let slideNum = parseInt(location.href.substring(tempIndex - 2, tempIndex),10);
                
                    // send Progress to parent
                    window.parent.postMessage({
                        type : 'responseJindo',
                        slideNum : slideNum,
                        slideUrl : location.href,
                        slideCount : 0,
                    },'*');
                }
            },false);
        }
    },
    mounted(){
        $('body').mouseover(function(){
            $('.sidepre').stop().animate({'left':'-65px'},100);
            $('.sidenext').stop().animate({'right':'-65px'},100);
        });
        $('body').mouseleave(function(){
            $('.sidepre').stop().animate({'left':'-120px'},100);
            $('.sidenext').stop().animate({'right':'-120px'},100);
        });
        this.cdmHandler();
    }
});

Vue.config.devtools = true;